import React from 'react';
import '../../../assests/css/button.scss';
import classNames from 'classnames';

export interface buttonProps {
    buttonText: string,
    onClick: ()=> void,
    loading?: boolean,
    type?: 'primary' | 'secondary' | 'primary-outline' | 'secondary-outline',
    buttonIconUrl?: string,
    selected?: boolean,
    customClassName?: string,
    disable?: boolean,
}

export default function Button(props: buttonProps) {

    const {buttonText, loading, buttonIconUrl, type,
        customClassName, disable, onClick} = props;

    const getButtonClass = () => {
        const className = classNames('button-container', customClassName ? customClassName : '');
        switch (type) {
            case 'primary':
                return `${className} primary`;
            case 'primary-outline':
                return `${className} primary-outline`;
            case 'secondary':
                return `${className} secondary`;
            case 'secondary-outline':
                return `${className} secondary-outline`;
            default:
                return `${className}`;
        }
    }

    const handleClick = () => {
        if (!disable) {
            onClick();
        }
    };

    return (
        <div className={getButtonClass()}
            onClick={handleClick} data-disabled={disable}>
            {buttonIconUrl? <img className="button-icon" src={buttonIconUrl} alt="btn-icon"/>: null}
            <span className="button-text">{buttonText}</span>
            {loading? <span className="loader"></span>: null}
        </div>
    )

}